import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import {
  getAllianceLeadFromMoneyTapInput,
  sourceConvert,
} from "../../../../../utility/commonUtils";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { TRACK_ID } from "../../../../../utility/enum";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

const OfferPage = ({
  formData,
  setFormData,
  setCurrentStep,
  setShowOfferHeaderLogo,
}) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const token = user?.token;
  const [failedList, setFailedList] = useState([]);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    if (formData.stepDone === 3 && !leadId) {
      submitLead();
    }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        const hardcodedLender = {
          _id: "662752eb65fdba1a48d6e482",
          lender_name: "L&T",
        };

        const mergedLenders = [...apiLenders, hardcodedLender];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name:
        "personal-details-submit-for-website-Ploan-offers-tata-capital",
      user_id: formData.mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
    try {
      const trackId = localStorage.getItem(TRACK_ID);
      const processedLead = getAllianceLeadFromMoneyTapInput(
        "website-pl-non-pan",
        {
          ...formData,
          ...user,
        }
      );
      console.log("Processed Lead: ", processedLead);
      const res = await callApi(
        "v1/lead/pa_lead_check",
        "post",
        {
          lead: {
            ...processedLead,
            tracking_id: trackId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source"),
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            alliance_id: "pre",
            from_preapprove: true,
          },
          lender_id: "6884500b77e489de0c1124ba",
        },
        "core",
        user.token
      );

      if (res.status === "Success" && res?.data?.lead) {
        console.log("Lead created successfully:", res?.data);
        const newLeadId = res.data.lead._id;
        const contactPhone = res.data.lead.contact_phone;
        setLeadId(newLeadId);

        setUserClickData({
          event_name: "process-lead-for-pa-tatacapital",
          user_id: contactPhone || newLeadId || "No User ID found here",
          affiliate_id: params.get("aff_id") || "No Aff_id found",
        });
        // fetchOffers(newLeadId);
        let attempt = 0;
        const maxAttempts = 6;
        const interval = setInterval(async () => {
          attempt++;
          const offerFound = await fetchOffers(newLeadId);
          if (offerFound || attempt === maxAttempts) {
            clearInterval(interval);
            if (!offerFound) setIsFinished(true);
          }
        }, 5000);

        const firstResult = await fetchOffers(newLeadId);
        if (firstResult) clearInterval(interval);
      }
    } catch (err) {
      toast("Some error occurred", { hideProgressBar: true, type: "error" });
      console.log(err);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      // 1️⃣ Fetch offers by lead ID
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        user.token
      );

      if (res.status === "Success" && res.data?.offers?.length > 0) {
        console.log(res);

        const offers = res.data.offers;

        // ✅ 2️⃣ Fetch Success + Fail lenders
        const lenderListRes = await callApi(
          `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
          "post",
          {},
          "loan",
          user.token
        );

        // ✅ Store Faillist
        if (Array.isArray(lenderListRes.data?.FailList)) {
          setFailedList(lenderListRes.data.FailList);
        }

        // ✅ 3️⃣ Create lookup map from Successlist
        let lenderMap = {};
        if (Array.isArray(lenderListRes.data?.Successlist)) {
          lenderMap = Object.fromEntries(
            lenderListRes.data.Successlist.map((l) => [l.lender_id, l])
          );
        }

        // ✅ 4️⃣ Enrich offers with Successlist fields
        const enrichedOffers = offers.map((offer) => {
          const lender = lenderMap[offer.lender_id] || {};

          return {
            ...offer,
            apr: lender.apr ?? "",
            kfs_doc: lender.kfs_doc ?? "",
            credit_limit: lender.web_offer ?? "",
            penal_charges: lender.penal_charges ?? "",
            processing_fee: lender.processing_fee ?? "",
            interest_rate: lender.web_interest ?? null,
            lender_name: lender.lender_name ?? offer.lender_name,
          };
        });

        // ✅ 5️⃣ Sort by priority
        const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

        // ✅ 6️⃣ Filter by active lenders (if applicable)
        const filteredOffers = activeLenders.length
          ? sortedOffers.filter((offer) =>
              activeLenders.some((l) => l._id === offer.lender_id)
            )
          : sortedOffers;

        // ✅ 7️⃣ Dispatch to Redux
        dispatch(setOffers(filteredOffers));

        // ✅ 8️⃣ Mark finished
        setIsFinished(true);

        return true;
      }

      return false;
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return false;
    }
  };

  return (
    <div id="offer-page-v5">
      {
        offers.length > 0 ? (
          <>
            <div className="final-offers-container-v5">
              <>
                <img
                  src="/assets/img/pre_Offer_page_BG_image1.png"
                  alt="Square Check Background"
                  className="background-overlay-img-offer"
                />
              </>

              <div className="offer-bg-layer-v5">
                <h2 className="congrats-text1-pre">Congratulations!</h2>
                <h3 className="sub-text1-pre">You’re Pre-Qualified for</h3>
                <h3 className="sub-text1-pre">a Personal Loan!</h3>
              </div>
            </div>

            <div className="offer-cards-container-xyz">
              {offers.map((offer) => (
                <OfferCard
                  key={offer._id}
                  offer={offer}
                  isExpanded={expandedOfferId === offer._id}
                  onExpand={() => setExpandedOfferId(offer._id)}
                />
              ))}
              <div
                className="p-4 rounded-xl bg-white-900/80  backdrop-blur-md shadow-lg mx-2"
                style={{ backgroundColor: "white" }}
              >
                {/* Note Header */}
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-semibold uppercase tracking-wide text-red-500">
                    Note
                  </span>
                </div>

                {/* Note Text */}
                <p className="text-sm text-black-300 mb-4 leading-relaxed">
                  {failedList?.length > 0 && (
                    <p className="text-sm text-black-300 mb-2">
                      There are no matching offers for your request from:{" "}
                      {failedList.join(", ")}
                    </p>
                  )}
                </p>
              </div>
              <p className="disclaimer-offer-text-v5">
                Choose from these incredible offers that best suit your needs
              </p>
              <p className="disclaimer-text">
                *These pre-approved offers are subject to change at discretion
                of Bank / NBFC after receiving all your documents and details.
                Final offer will be based on risk policy of Bank / NBFC. We do
                not guarantee that final offer will be same as Pre-approved
                offer.
              </p>
            </div>
          </>
        ) : isFinished ? (
          setShowOfferHeaderLogo(true) || (
            <div className="no-offers-found">
              <h2 className="congrats-text">
                There is no offer for you currently.
              </h2>
            </div>
          )
        ) : (
          setShowOfferHeaderLogo(true) || (
            <div className="no-offers-found">
              <h2 className="congrats-text">
                Please wait while we are searching best offers for you
              </h2>
            </div>
          )
        )

        // ) : isFinished ? (
        //   <div className="no-offers-found">
        //     <h2 className="congrats-text">
        //       There is no offer for you currently.
        //     </h2>
        //   </div>
        // ) : (
        //   <div className="no-offers-found">
        //     <h2 className="congrats-text">
        //       Please wait while we are searching best offers for you
        //     </h2>
        //   </div>
        // )
      }
    </div>
  );
};

export default OfferPage;
